import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { MelissaModel } from "@insite/client-framework/Types/ApiModels";

const melissaId = "109805859";
const returnFormat = "json";
const action = "Check";
const options = "AdvancedAddressCorrection:on"

export interface MelissaApiParameter extends ApiParameter {
    comp?: string;
    a1?: string;
    a2?: string;
    city?: string;
    state?: string;
    postal?: string;
    ctry?: string;
}

const melissaUrl = "https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify";

export async function getValidationResult(parameter: MelissaApiParameter): Promise<MelissaModel> {
    const melissaModel: MelissaModel = await getMelissaResult(parameter);
    return melissaModel;
}

function getMelissaResult(parameter: MelissaApiParameter): Promise<MelissaModel> {
    let uri = `${ melissaUrl }`;

    const query = `?id=${ melissaId }&format=${ returnFormat }&act=${ action }&opt=${ options }&${ parseParameters(parameter) }`;
    uri += query;
    uri = uri.replace(/&$/, "");

    return new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        const params = JSON.stringify(parameter);

        let uri = `${ melissaUrl }`;

        const query = `?id=${ melissaId }&format=${ returnFormat }&act=${ action }&${ parseParameters(parameter) }`;
        uri += query;
        uri = uri.replace(/&$/, "");

        request.open("GET", uri, true);
        request.responseType = "json";

        request.addEventListener("readystatechange", () => {
            if (request.readyState === 4 && request.status === 200) {
                resolve(request.response);
            } else if (request.readyState === 4) {
                reject();
            }
        });
        request.send(params);
    });
}

function parseParameters(parameters: { [key: string]: any }): string {
    let query = "";
    for (const property in parameters) {
        if (parameters[property] && parameters[property].constructor === Array) {
            parameters?.forEach(parameters[property], (value: any) => {
                    query += `${property}=${value}&`;
                });
        } else if (parameters[property]) {
            query += `${property  }=${  encodeURIComponent(parameters[property])  }&`;
        }
    }
    return query;
}